import { render, staticRenderFns } from "./WxAppList.vue?vue&type=template&id=129f135d"
import script from "./WxAppList.vue?vue&type=script&lang=js"
export * from "./WxAppList.vue?vue&type=script&lang=js"
import style0 from "./WxAppList.vue?vue&type=style&index=0&id=129f135d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports